import { render } from "./AsahiButton.vue?vue&type=template&id=5cfb8911&scoped=true"
import script from "./AsahiButton.vue?vue&type=script&lang=js"
export * from "./AsahiButton.vue?vue&type=script&lang=js"

import "./AsahiButton.vue?vue&type=style&index=0&id=5cfb8911&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfb8911"]])

export default __exports__